<template>
  <div class="IncrementalData-fieldWrap">
    <div class="IncrementalData-field">
      <div
        class="IncrementalData-question"
        data-rmpdev-selector="jobTypes-field"
      >
        <label
          class="IncrementalData-questionText"
        >
          What type of job are you interested in?
        </label>
        <div class="IncrementalData-questionField">
          <form-autocomplete
            v-model="fields.jobTypes"
            :error="validateStatus({ field: v$.fields.jobTypes, serverKey: 'jobTypes', label: 'Job type' })"
            :manual-validate="validateAll"
            :items="jobTypes"
            :hint="hint"
            required
            class="JobTypes-field"
            multiple
            data-rmpdev-field-selector="jobTypes"
            placeholder="Select a job type"
            @change="validateBlur({ field: v$.fields.jobTypes, serverKey: 'jobTypes' })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import { mapState, mapActions } from 'vuex';
import FormAutocomplete from '@/components/form/autocomplete-select';
import useVuelidate from '@vuelidate/core';
import incrementalMixin from '../mixins/incremental-data-field-mixin';

export default {

  components: {
    FormAutocomplete,
  },

  mixins: [incrementalMixin],

  data() {
    return {
      v$: useVuelidate(),
      fields: {
        jobTypes: null,
      },
      fieldName: 'job_types',
      hint: {
        type: 'warning',
        hint: 'You may select more than one',
      },
    };
  },

  computed: {
    ...mapState('entities', {
      jobTypes: (state) => state.jobTypes,
    }),
    updatePayload() {
      return {
        jobTypes: this.fields.jobTypes.map((jobType) => jobType.id),
      };
    },
  },

  mounted() {
    Promise.all([
      this.getJobTypes(),
    ]).then(() => {
      if (this.user.jobTypes.length) {
        this.fields.jobTypes = this.user.jobTypes;
      }
    });
  },

  methods: {
    ...mapActions('entities', {
      getJobTypes: 'getJobTypes',
    }),
  },

  validations() {
    const rules = {
      fields: {
        jobTypes: { required },
      },
    };

    return rules;
  },
};
</script>
